import * as React from 'react';
import { ContentState, ContentBlock } from 'draft-js';
import { ImageBlock } from './ImageBlock';

interface IProps {
  contentState: ContentState;
  block: ContentBlock;
  blockProps?: {
    updateEntityData?: (newContentState: ContentState, changeType?: string) => void;
  };
}

export const AtomicBlock: React.FC<IProps> = (props) => {
  const { contentState, block } = props;
  const entityKey = block.getEntityAt(0);

  if (!entityKey) {
    return null;
  }

  const entity = contentState.getEntity(entityKey);
  const entityType = entity.getType();

  switch (entityType) {
    case 'IMAGE':
      return (
        <ImageBlock
          contentState={contentState}
          entityKey={entityKey}
          blockKey={block.getKey()}
          offsetKey={`${block.getKey()}-0-0`}
          updateEntityData={props.blockProps?.updateEntityData}
        />
      );
    default:
      return <div>Unsupported atomic block type: {entityType}</div>;
  }
};

AtomicBlock.displayName = 'AtomicBlock';
